var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"cascader-item"},[_c('p',{staticClass:"cascader-item-p",on:{"click":function($event){return _vm.router(_vm.data)}}},[_vm._v(_vm._s(_vm.data.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }